import React from 'react';

import './Filters.scss';
import { FilterAttributes } from "../FilterAttributes/FilterAttributes";
import { FilterBar } from "../FilterBar/FilterBar";
import { ResultsFiltering } from '../ResultsFiltering/ResultsFiltering';

export class Filters extends React.Component<any, any> {

    constructor(props) {
        super(props);
    }

    render() {
        return <div className="algolia-filters">
            <FilterBar toggleFilter={this.props.toggleFilter} {...this.props} />
            <ResultsFiltering hideFilterModal={this.props.hideFilterModal} {...this.props} />
            <FilterAttributes hideFilter={this.props.hideFilter} toggleFilter={this.props.toggleFilter} {...this.props} />
            <div className="algolia-filters-toggle">
                <button className="algolia-filters-toggle__button" type="button" onClick={() => { this.props.toggleFilterModal() }}>Apply Filters</button>
            </div>
        </div>;
    }
}
